import _ from 'lodash';
import {createSelector} from 'reselect';

import {CustomFieldResourceTypesEnum} from '../../../models/api/customFieldModel';
import {AppState} from '../../appState';
import {getHasCannedAnswersResourceCustomFields} from '../../featureFlags/featureFlagsSelectors';
import {getCustomFields} from '../dataSelectors';

/*
 * Constants.
 */

export const interpolationResourceTypes = Object.freeze([
  CustomFieldResourceTypesEnum.CARD,
  CustomFieldResourceTypesEnum.TEAMMATE,
  CustomFieldResourceTypesEnum.ACCOUNT,
  // TODO: Add inbox types.
  // CustomFieldResourceTypesEnum.INBOX,
]);

/*
 * Selectors.
 */

export const getCustomFieldsForCards = createSelector([getCustomFields], (customFields) =>
  _(customFields)
    .pickBy((cf) => cf && cf.resourceType === CustomFieldResourceTypesEnum.CARD)
    .value(),
);

export const getCustomFieldsForCardsFlat = createSelector([getCustomFieldsForCards], (customFields) =>
  _(customFields).values().compact().value(),
);

export const getCustomFieldsForAccounts = createSelector([getCustomFields], (customFields) =>
  _(customFields)
    .pickBy((cf) => cf && cf.resourceType === CustomFieldResourceTypesEnum.ACCOUNT)
    .value(),
);

export const getCustomFieldsForAccountsFlat = createSelector([getCustomFieldsForAccounts], (customFields) =>
  _(customFields).values().compact().value(),
);

export const getCustomFieldsForInterpolation = createSelector(
  [getHasCannedAnswersResourceCustomFields, getCustomFields],
  (hasResourceCustomFields, customFields) =>
    _(customFields)
      .pickBy((cf) => {
        if (!cf) {
          return false;
        }
        if (!hasResourceCustomFields) {
          return cf.resourceType === CustomFieldResourceTypesEnum.CARD;
        }

        return interpolationResourceTypes.includes(cf.resourceType);
      })
      .value(),
);

export const makeGetCustomFieldsForResource = () =>
  createSelector(
    getCustomFields,
    (_state: AppState, type: CustomFieldResourceTypesEnum) => type,
    (customFields, type) =>
      _(customFields)
        .pickBy((cf) => cf && cf.resourceType === type)
        .value(),
  );
